var __symbolPrefix = "3r/message-api/message-processors/"

function MessageProcessors (_, Device, Radical, $timeout) {
    var processors = []
    var update = []
    var data = []
    var lookup
    var debouncedApply = _.debounce(apply, 100)
    var hasProcessedAccept = null

    function timeoutOrNot(fn) {
        if (typeof $timeout == "function") {
            return $timeout(fn)
        } else {
            return fn()
        }
    }

    async function apply() {
        if(!Device.info || !Device.info.messages) return
        //Remove all existing items
        data.length = 0
        _.forEach(Device.info.messages, function (m) {
            m.istaken = false
        })
        //Call all of the processors
        await Radical.invokeParams(processors, data, Device.info.messages, data, Device.info)
        //Ensure that the data array contains no arrays
        for (var i = data.length - 1; i >= 0; i--) {
            if (isArray(data[i])) {
                _.forEach(_.flatten(data[i]), function (i) {
                    data.push(i)
                })
            }
        }
        // var undata = _.filter(data, function (d) {
        //     return !angular.isArray(d)
        // })
        data = _.uniq(_.filter(data, function (d) {
            d.categories = d.categories || {}
            return !isArray(d)
        }), 'id')

        if (typeof _.indexBy == "function") {
            lookup = _.indexBy(data, 'id')
        } else {
            lookup = _.keyBy(data, 'id')
        }

        //Tell everything that cares
        Radical.invokeParams(update, data, data)

    }

    var hasProcessed = new Promise(function (accept, reject) {
        hasProcessedAccept = accept
        timeoutOrNot(function () {
            return Device.on('info', function (info) {
                timeoutOrNot(function () {
                    hasProcessedAccept = null
                    accept(apply())
                })
            })
        })
    })
//
    return Object.defineProperties({
        hasProcessed : hasProcessed,
        add: function (processor, priority) {
            processor.$priority = priority
            processors.push(processor)
            processors = _.sortBy(processors, function (p) {
                return p.$priority || 100
            })
            debouncedApply()
        },
        updated: function (fn) {
            update.push(fn)
        },
        offUpdated: function (fn) {
            var idx = update.indexOf(fn)
            if (idx != -1) {
                update.splice(idx, 1)
            }
        },
        update: function() {
            return timeoutOrNot(apply).then(function (res) {
                if (hasProcessedAccept) {
                    hasProcessedAccept(res)
                }

                return res
            })
        }
    }, {
        current: {
            get: function () {
                return data
            }
        },
        lookup: {
            get: function () {
                return lookup
            }
        }
    })

    function isArray(obj) {
        
        return typeof obj == "object" && typeof obj.length == "number" && typeof obj.forEach == "function"
    }
}

MessageProcessors._depends = {
    symbol : __symbolPrefix + "MessageProcessors",
    modules : [
        "_",
        "3r/Device",
        "3r/device-api/helpers/Radical"
    ]
}

exports.MessageProcessors = MessageProcessors
